import { render, staticRenderFns } from "./examDetail1.vue?vue&type=template&id=5e3aa20c&scoped=true&"
import script from "./examDetail1.vue?vue&type=script&lang=js&"
export * from "./examDetail1.vue?vue&type=script&lang=js&"
import style0 from "./examDetail1.vue?vue&type=style&index=0&id=5e3aa20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3aa20c",
  null
  
)

export default component.exports